import { cn } from "@/lib/utils";
import type { Progress } from "@/lib/domain";

export function ProgressBar({
  progress,
  className,
}: {
  progress: Progress;
  className?: string;
}) {
  return (
    <div className={cn("w-full", className)}>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/12">
        <div
          className="h-full rounded-full bg-gradient-to-r from-magenta to-pink transition-[width]"
          style={{ width: `${progress.pct}%` }}
        />
      </div>
      <div className="mt-1.5 flex items-center gap-3 text-[0.62rem] text-ice/60">
        <span className="num">{progress.pct}%</span>
        <span>
          {progress.approved}/{progress.total} fasi approvate
        </span>
        {progress.reported > 0 && (
          <span className="text-pink">{progress.reported} da approvare</span>
        )}
        {progress.issues > 0 && (
          <span className="text-rose">{progress.issues} anomalie</span>
        )}
      </div>
    </div>
  );
}

const STAGE_TONE: Record<string, string> = {
  approved: "border-green/50 bg-green/15 text-green",
  reported: "border-pink/50 bg-pink/15 text-pink",
  in_progress: "border-gold/50 bg-gold/10 text-goldbright",
  issue: "border-rose/60 bg-rose/20 text-pink",
  pending: "border-white/15 bg-white/5 text-ice/55",
};

export function StatusPill({
  status,
  label,
  className,
}: {
  status: string;
  label: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[0.6rem] font-semibold uppercase tracking-[0.14em]",
        STAGE_TONE[status] ?? STAGE_TONE.pending,
        className,
      )}
    >
      {label}
    </span>
  );
}
